import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { checkAdminAuth, handleAdminAuthError } from '../utils/auth';

const AdminProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const initAdmin = async () => {
      try {
        await checkAdminAuth();
        setIsAdmin(true);
      } catch (error) {
        handleAdminAuthError(error);
      } finally {
        setIsLoading(false);
      }
    };

    initAdmin();
  }, [navigate, location.pathname]);

  if (isLoading) {
    return (
      <div className="admin-loading" style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: '1rem',
        background: '#f2f3f5'
      }}>
        <div className="admin-loading__spinner" style={{
          width: '3rem',
          height: '3rem',
          border: '3px solid #f2f3f5',
          borderTop: '3px solid #d52b1e',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <p style={{ margin: 0, color: '#747474' }}>Проверка прав доступа...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!isAdmin) {
    return null;
  }

  return children;
};

export default AdminProtectedRoute;